import { PaginatedResponse } from './common';
import { RowPermissions } from './surveySet.types';

export enum FaqCategory {
  GENERAL = 'GENERAL',
  WALLET = 'WALLET',
  SURVEY = 'SURVEY',
  PROJECT = 'PROJECT',
  OTHER = 'OTHER',
}

export enum FaqStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DRAFT = 'DRAFT',
}

export interface FaqMetaData {
  count: number;
  pages: number;
  limit: number;
  totalPages: number;
}
export interface Faq {
  id: number;
  question: string;
  answer: string;
  category?: FaqCategory | null;
  status: FaqStatus | null;
  createdAt: string;
  updatedAt: string;
  createdBy?: string | null;
  updatedBy?: string | null;
  isDeleted: boolean;
  deletedBy?: string | null;
  deletedAt?: string | null;
  _permissions?: RowPermissions;
}

export interface PaginatedFaqResponse {
  data: Faq[];
  meta: FaqMetaData;
}

export type AllFaqsResponseDto = PaginatedResponse<Faq[], null>;

export interface ApiResponse<T> {
  success?: boolean;
  message?: string;
  data: T;
}

export interface FaqCreateDto {
  question: string;
  answer: string;
  category?: FaqCategory | null;
  status?: FaqStatus;
  createdBy?: string | null;
}

export interface FaqUpdateDto {
  question?: string;
  answer?: string;
  category?: FaqCategory;
  status?: FaqStatus;
  updatedBy?: string;
}

export interface FaqInfoCount {
  activeFaqs: number;
  inactiveFaqs: number;
  totalFaqs: number;
}
export interface FaqFilterParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: FaqStatus | null;
}
